// extracted by mini-css-extract-plugin
module.exports = {"promoThanks":"styles_promoThanks__n986Q","promoTitle":"styles_promoTitle__3aqHV","promoBody":"styles_promoBody__aZSlu"};